<template lang="pug">
    .container
        h2
            | Hospitalizaciones
        .wrapper-listado
            .border-wrap
                .listado-header
                    .accion-listado
                        .action(v-if="isMedic")
                          router-link(:to="{name:'new-hospitalization' }")
                            | Nueva visita
            .wrapper-body
                table.table.table-striped
                    tbody
                        tr(v-for="(visit, $index) in visits" v-bind:key="$index")
                            td
                                | {{visit.patient}}
                            td
                                | {{visit.date}}
                            td
                              router-link(:to="{ 'name': 'hospitalization', 'params': { id:  visit.address }}")
                                | Ver datos
                              router-link.ml-2(:to="{ 'name': 'hospitalization-timeline', params: { id: visit.address }}")
                                | Timeline
 
</template>

<script>
import visitsManager from "../managers/visitsManager";
import Gun from "gun";
const sea = Gun.SEA;
import gun from "../managers/gun";
export default {
  data() {
    return {
      visits: []
    };
  },
  props: ["isMedic"],
  methods: {
    async refreshContracts() {
      let profile 
      this.visits = []
      console.log("refresh")
      gun
        .get("hospitalizations")
        .map()
        .once(async (publicVisit, v) => {
          if (publicVisit.patient == gun.user()._.sea.pub || publicVisit.medic == gun.user().is.pub) {
            let secret
            let patientUser
            if(this.isMedic) {
             patientUser = await gun.user(publicVisit.patient);

               secret = await sea.secret(patientUser.epub, gun.user()._.sea);
            } else {
                patientUser = await gun.user(publicVisit.medic);
              
               secret = await sea.secret(patientUser.epub, gun.user()._.sea);
            }
            profile =  await gun.user(publicVisit.patient).get("profile")
            var encryptedData = await gun.get("hospitalizations").get(v).get("data")
            let decrypted = await sea.decrypt(encryptedData, secret);
            let visit = await visitsManager.GetVisit(decrypted.externalID);
            let msg = await visit.methods.getDate();
            msg.call((i, val) => {
              let date = new Date();
              date.setTime(val);
              date = date.toLocaleDateString()
              this.visits.push({
                patient: profile.name,
                address: v,
                date: date
              });
            });
          }
        });

   
    }
  },
  created() {
    setTimeout(this.refreshContracts,  2000);
  }
};
</script>
<style lang="scss" scoped>
</style>
